"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepOfferNotificationSubscription = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const types_1 = require("@src/types");
const elements_1 = require("@src/components/elements");
const Api = __importStar(require("@src/api"));
const LocationSelect_1 = require("@src/components/modules/forms/offer-notification-subscription-form/LocationSelect");
const job_area_select_field_1 = require("@src/components/modules/forms/job-area-select-field");
const account_context_1 = require("@src/context/account-context");
const typeSelectFields_1 = require("@src/components/modules/forms/type-select-field/typeSelectFields");
const salaryRangeField_1 = require("@src/components/modules/forms/salary-range-field/salaryRangeField");
const specific_search_select_field_1 = require("@src/components/modules/forms/specific-search-select-field");
const offer_notification_subscription_validation_rules_1 = require("@src/components/modules/forms/offer-notification-subscription-form/offer-notification-subscription-validation-rules");
const convert_selected_locations_1 = require("@src/helpers/convert-selected-locations");
const offer_filter_context_1 = require("@src/components/pages/offers/offer-filter-context");
const OfferSearchFilterWrapper_style_1 = require("@src/components/pages/offers/modules/OfferSearchFilterWrapper.style");
const StepOfferNotificationSubscription_style_1 = require("./StepOfferNotificationSubscription.style");
const StepOfferNotificationSubscription = react_1.default.forwardRef(({ setIsLoading }, ref) => {
    const intl = (0, react_intl_1.useIntl)();
    const [subscription, setSubscription] = react_1.default.useState(null);
    const [isInitialized, setIsInitialized] = react_1.default.useState(false);
    const [showLocationPlaceholder, setShowLocationPlaceholder] = react_1.default.useState(true);
    const account = (0, account_context_1.useAccount)();
    const [form] = antd_1.Form.useForm();
    const [formValues, setFormValues] = react_1.default.useState(form.getFieldsValue());
    const { subscriptionFilterRules, salaryMaxValidationRules } = (0, offer_notification_subscription_validation_rules_1.getValidationRules)({ intl, formValues });
    const showErrorNotification = () => {
        antd_1.notification.error({
            message: intl.formatMessage({ id: 'onboarding.error.title' }),
            description: intl.formatMessage({ id: 'onboarding.error.description' }),
        });
    };
    const initialize = async () => {
        var _a;
        try {
            const fetchedSubscription = await Api.OfferNotificationSubscription.getSubscription();
            const specificSearch = (0, offer_filter_context_1.formatCombinedValues)({
                companies: (fetchedSubscription === null || fetchedSubscription === void 0 ? void 0 : fetchedSubscription.companies) || [],
                keywords: (fetchedSubscription === null || fetchedSubscription === void 0 ? void 0 : fetchedSubscription.keywords) || [],
                skillTags: (fetchedSubscription === null || fetchedSubscription === void 0 ? void 0 : fetchedSubscription.skillTags) || [],
            });
            setSubscription(fetchedSubscription);
            const initialValues = {
                shouldSendEmail: true,
                jobAreaIds: (fetchedSubscription === null || fetchedSubscription === void 0 ? void 0 : fetchedSubscription.jobAreaIds) || [],
                selectedLocations: (fetchedSubscription === null || fetchedSubscription === void 0 ? void 0 : fetchedSubscription.locationIds) || [],
                typeIds: (fetchedSubscription === null || fetchedSubscription === void 0 ? void 0 : fetchedSubscription.typeIds) || [],
                salaryRate: fetchedSubscription === null || fetchedSubscription === void 0 ? void 0 : fetchedSubscription.salaryRate,
                salaryMin: fetchedSubscription === null || fetchedSubscription === void 0 ? void 0 : fetchedSubscription.salaryMin,
                salaryMax: fetchedSubscription === null || fetchedSubscription === void 0 ? void 0 : fetchedSubscription.salaryMax,
                specificSearch,
            };
            if ((fetchedSubscription === null || fetchedSubscription === void 0 ? void 0 : fetchedSubscription.is_remote) && !initialValues.selectedLocations.includes(types_1.REMOTE)) {
                initialValues.selectedLocations.push(types_1.REMOTE);
            }
            if ((fetchedSubscription === null || fetchedSubscription === void 0 ? void 0 : fetchedSubscription.is_abroad) && !initialValues.selectedLocations.includes(types_1.ABROAD)) {
                initialValues.selectedLocations.push(types_1.ABROAD);
            }
            form.setFieldsValue(initialValues);
            setFormValues(initialValues);
        }
        catch (err) {
            if (((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status) !== 404) {
                console.error(err);
                showErrorNotification();
            }
        }
        finally {
            setIsInitialized(true);
        }
    };
    react_1.default.useEffect(() => {
        initialize();
    }, []);
    const submit = async () => {
        await form.validateFields();
        const formData = form.getFieldsValue();
        setIsLoading(true);
        try {
            const subscriptionData = {
                selectedLocations: (0, convert_selected_locations_1.convertSelectedLocations)(formData.selectedLocations),
                jobAreaIds: formData.jobAreaIds,
                email: account.email,
                typeIds: formData.typeIds,
                salaryRate: formData.salaryRate,
                salaryMin: formData.salaryMin,
                salaryMax: formData.salaryMax,
                specificSearch: formValues.specificSearch,
            };
            const subscriptionNotificationsSettings = {
                [types_1.NotificationType.OFFER_SUBSCRIPTION_NOTIFICATION]: {
                    is_enabled: true,
                    should_send_email: formData.shouldSendEmail,
                },
            };
            if (subscription) {
                await Promise.all([
                    Api.OfferNotificationSubscription.updateSubscription(subscriptionData, subscription.token),
                    Api.Account.updateMyNotificationTypeSettings(subscriptionNotificationsSettings),
                ]);
            }
            else {
                await Promise.all([
                    Api.OfferNotificationSubscription.createSubscription(subscriptionData),
                    Api.Account.updateMyNotificationTypeSettings(subscriptionNotificationsSettings),
                ]);
            }
        }
        catch (err) {
            console.error(err);
            showErrorNotification();
        }
        finally {
            setIsLoading(false);
        }
    };
    react_1.default.useImperativeHandle(ref, () => ({ saveSubscriptionAndNotificationSettings: submit }));
    return ((0, jsx_runtime_1.jsxs)(StepOfferNotificationSubscription_style_1.OfferNotificationSubscriptionStepWrapper, { children: [(0, jsx_runtime_1.jsx)(StepOfferNotificationSubscription_style_1.TextWrapper, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "onboarding.offer_subscription.text" }) }), !isInitialized && ((0, jsx_runtime_1.jsx)(StepOfferNotificationSubscription_style_1.SpinnerWrapper, { children: (0, jsx_runtime_1.jsx)(elements_1.Spinner, {}) })), isInitialized && ((0, jsx_runtime_1.jsxs)(antd_1.Form, { name: "offerSubscriptionWizardStep", layout: "vertical", form: form, onValuesChange: values => setFormValues({ ...formValues, ...values }), children: [(0, jsx_runtime_1.jsxs)(antd_1.Row, { justify: "space-around", children: [(0, jsx_runtime_1.jsx)(antd_1.Col, { xs: { span: 24 }, md: { span: 11 }, children: (0, jsx_runtime_1.jsx)(typeSelectFields_1.TypeSelectField, { label: intl.formatMessage({ id: 'onboarding.offer_subscription.type' }), name: "typeIds", rules: subscriptionFilterRules, maxTagCount: "responsive", maxTagTextLength: 25 }) }), (0, jsx_runtime_1.jsxs)(antd_1.Col, { xs: { span: 24 }, md: { span: 11 }, children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, { className: "m-b-l", label: intl.formatMessage({ id: 'onboarding.offer_subscription.location' }), name: "selectedLocations", validateTrigger: "onSubmit", rules: subscriptionFilterRules, children: (0, jsx_runtime_1.jsx)(LocationSelect_1.LocationSelect, { setShowLocationPlaceholder: setShowLocationPlaceholder }) }), showLocationPlaceholder && ((0, jsx_runtime_1.jsx)(OfferSearchFilterWrapper_style_1.ForcedPlaceholder, { className: "ant-select-selection-placeholder", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "global.location.placeholder" }) }))] })] }), (0, jsx_runtime_1.jsxs)(antd_1.Row, { justify: "space-around", children: [(0, jsx_runtime_1.jsx)(antd_1.Col, { xs: { span: 24 }, md: { span: 11 }, children: (0, jsx_runtime_1.jsx)(job_area_select_field_1.JobAreaSelectField, { label: intl.formatMessage({ id: 'onboarding.offer_subscription.job_area' }), maxTagCount: "responsive", maxTagTextLength: 25, name: "jobAreaIds", rules: subscriptionFilterRules }) }), (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: { span: 24 }, md: { span: 11 }, children: (0, jsx_runtime_1.jsx)("div", { className: "flex-center", children: (0, jsx_runtime_1.jsx)(salaryRangeField_1.SalaryRangeField, { form: form, maxRules: salaryMaxValidationRules, rateRules: subscriptionFilterRules }) }) })] }), (0, jsx_runtime_1.jsx)(antd_1.Row, { justify: "space-around", children: (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: { span: 24 }, md: { span: 24 }, children: (0, jsx_runtime_1.jsx)(specific_search_select_field_1.SpecificSearchSelectField, { name: "specificSearch", rules: subscriptionFilterRules, formValues: formValues, setFormValues: setFormValues }) }) }), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { style: { textAlign: 'center' }, name: "shouldSendEmail", valuePropName: "checked", children: (0, jsx_runtime_1.jsx)(antd_1.Checkbox, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "onboarding.offer_subscription.email_notifications" }) }) })] }))] }));
});
exports.StepOfferNotificationSubscription = StepOfferNotificationSubscription;
